import DialogStreak from '~/components/dialog/streak/DialogStreak.vue';

export const useDialogStreak = () => {
  const dialog = useDialogStore();

  const { t } = useNuxtApp().$i18n;

  const getNormalizedTextId = (count: number) => {
    switch (true) {
      case count >= 100:
        return '100';
      case count >= 50:
        return '50';
      case count >= 30:
        return '30';
      case count >= 15:
        return '15';
      case count >= 12:
        return '12';
      case count >= 10:
        return '10';
      case count >= 7:
        return '7';
      case count >= 5:
        return '5';
      case count >= 3:
        return '3';
      default:
        return `${count}`;
    }
  };

  const getTexts = (count: number) => {
    return {
      title: t(`streak.day-${getNormalizedTextId(count)}.title`, {
        count,
      }),
      details: t(`streak.day-${getNormalizedTextId(count)}.details`, {
        count,
        daysLeftFrom30: 30 - count,
      }),
      action: t(`streak.day-${getNormalizedTextId(count)}.action`),
    };
  };

  const open = async (count: number) => {
    return new Promise<void>((resolve) => {
      const { title, details, action } = getTexts(count);
      dialog.open(DialogStreak, {
        count,
        title,
        details,
        action,
        onClose: () => {
          resolve();
        },
      });
    });
  };

  return {
    open,
  };
};
